import React, { ReactNode, createContext, useContext, useEffect } from 'react';

interface MobileContextProps {
  isMobile: boolean;
}

const MobileContext = createContext<MobileContextProps | undefined>(undefined);

export const MobileProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isMobile, setIsMobile] = React.useState(false);

  useEffect(() => {
    const userAgent = navigator?.userAgent;
    const handleResize = () => {
      setIsMobile(/Android|iPhone|iPad|Tablet/i.test(userAgent) || window.innerWidth <= 800);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return <MobileContext.Provider value={{ isMobile }}>{children}</MobileContext.Provider>;
};

export const useMobile = (): MobileContextProps => {
  const mobile = useContext(MobileContext);
  if (!mobile) {
    return { isMobile: false };
  }
  return mobile;
};
